module.exports = __webpack_public_path__ + "img/icon__sharp-insert_photo-24px.6795aa32.svg";